
export default function TrustIndicators() {
  const stats = [
    {
      number: '500+',
      label: 'Projects Completed',
      icon: 'ri-checkbox-circle-fill',
      color: 'from-[#FF6B35] to-[#FF8C5A]'
    },
    {
      number: '10+',
      label: 'Years Experience',
      icon: 'ri-award-fill',
      color: 'from-[#0F4C81] to-[#1E88E5]'
    },
    {
      number: '100%',
      label: 'Licensed & Insured',
      icon: 'ri-shield-check-fill',
      color: 'from-[#FF6B35] to-[#FF8C5A]'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center group cursor-pointer"
            >
              <div className={`w-20 h-20 flex items-center justify-center bg-gradient-to-br ${stat.color} rounded-2xl mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${stat.icon} text-3xl text-white`}></i>
              </div>
              <div className="text-4xl lg:text-5xl font-black text-[#0F4C81] mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600 font-semibold">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
